import { ChangeDetectionStrategy, Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuctionManageService } from '../../services/auction-manage/auction-manage.service';
import { Store } from '@ngrx/store';
import * as DialogActions from 'app/dialog/features/dialog.actions';
import { loadManageCampaignList } from 'app/campaign/features/campaign.actions';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { CAMPAIGN_TYPE } from 'app/virtual-event/virtual-event.enums';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-auction-card',
  templateUrl: './auction-card.component.html',
  styleUrls: ['./auction-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuctionCardComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  @Input() auction
  @Input() userHandle

  public auctionStatus = 0

  public isDownloadHovered = false
  public img = '/images/org_logo_default_v2.svg'
  
  public statusHTML = '';

  constructor(
    public auctionManageService:AuctionManageService,
    private router: Router,
    public store: Store,
    public sharedService: SharedService,
  ) { }

  ngOnInit(): void {
    this.auctionManageService.getAuctionStatus(this.auction)
    if(this.auction){
      this.img = this.auction.imageUrl ? this.auction.imageUrl : "/images/org_logo_default_v2.svg"
    }
    
    this.statusHTML = this.auctionManageService.getAuctionStatusHtml(this.auction);
  }

  getAuctionStatus(){
        let result = this.auctionManageService.getAuctionStatus(this.auction)
        this.auctionStatus = result.status
        return result.status
  }

  getNumberStr(number){
   return this.auctionManageService.addCommasToNumber(number)
  }

  onPauseResumeClick(auction){
    let titleText = ''
    if(auction.campaignTypeData.auctionStatus == 0){
      titleText = `Do you want to stop bidding now for this ${auction.name} ?`
    }else{
      titleText = `Do you want to start bidding now for this "${auction.name}" ?`
    }

    const action = DialogActions.openDialog({
      payload: {
        name: "confirmComponent",
        options: {
          size: 'small',
          modalClass:'modal--paybee modal-sm',
          containerClass:'mdb-modal-backdrop-paybee'
        },
        initialState: {
          modalTitle: "Change of auction status",
          text: titleText,
          buttonCancel: "No",
          buttonConfirm: "Yes",
          callback: (result) => {
            if(result == false) {             
            }else{
              this.auctionManageService.setAuctionStatus(auction).pipe(
                takeUntilDestroyed(this.destroyRef)
              ).subscribe((data:any)=>{
                if(Object.keys(data).includes('success')){           
                    if(this.userHandle){
                      this.store.dispatch({
                        type: loadManageCampaignList.type,
                        payload:this.sharedService.token,
                        statusFilter:0,
                        campaignTypes:[CAMPAIGN_TYPE.AUCTION]
                      });
                    }
                  this.router.navigateByUrl(`/manageAuction/list`)
                }
              })
            }
          }
        }
      }
    });
    this.store.dispatch(action);
  }

  onStopClick(auction){
    let auctionStatus = auction.campaignTypeData.auctionStatus
    if(auctionStatus !== 2){
      const action = DialogActions.openDialog({
        payload: {
          name: "confirmComponent",
          options: {
            size: 'small',
            modalClass:'modal--paybee modal--paybee-red-title modal-sm',
            containerClass:'mdb-modal-backdrop-paybee'
          },
          initialState: {
            modalTitle: `Close "${auction.name}" Now`,
            text: `This Action is Irreversible.`,
            innerHtml:`
              This will result in following: <br>
                <div class="pl-2 pt-1">
                  1. No more bids will be allowed <br>
                  2. Winners will be notified with payment link.
                </div>`,
            buttonCancel: "No",
            buttonConfirm: "Yes",
            callback: (result) => {
              if(result == false) {             
              }else{
                  this.auctionManageService.onCloseAuction(auction).pipe(
                      takeUntilDestroyed(this.destroyRef)
                      ).subscribe((data:any)=>{
                      if(Object.keys(data).includes('success')){
                        if(this.userHandle){
                          this.store.dispatch({
                            type: loadManageCampaignList.type,
                            payload:this.sharedService.token,
                            statusFilter:0,
                            campaignTypes:[CAMPAIGN_TYPE.AUCTION]
                          });
                        }
                        this.router.navigateByUrl(`/manageAuction/list`)
                      }
                    })
              }
            }
          }
        }
      });
      this.store.dispatch(action);
    } 
  }

  onNotifyAuctionClosingClick(auction){
      window['orgMain'].notifyAuctionClosing(auction)
  }

  openAuctionManagePage(id, event){
    if(!event.target.matches('.noDetaisClick')){
          this.router.navigate([`/manageAuction/${id}`], { fragment: "auctionsTab" })
    }
  }
}
